import button from "./basic/button";
import heading from "./basic/heading";
import icon from "./basic/icon";
import image from "./basic/image";
import imagesList from "./basic/images-list";
import list from "./basic/list";
import paragraph from "./basic/paragraph";
import quote from "./basic/quote";
import codesandbox from "./code/codesandbox";
import iframe from "./embeds/iframe";
import soundcloud from "./embeds/soundcloud";
import vimeo from "./embeds/vimeo";
import youtube from "./embeds/youtube";
import pinterest from "./social/pinterest";
import twitter from "./social/twitter";

export default () => [
    button,
    heading,
    icon,
    image,
    imagesList,
    list,
    paragraph,
    quote,
    codesandbox,
    iframe,
    soundcloud,
    vimeo,
    youtube,
    pinterest,
    twitter
];
